import React from 'react'
import DayItem from './DayItem'
import { ScheduleDayModel } from '../types/ScheduleTypes'
import moment from 'moment'

const DayWrapper = ({
  day,
  height,
  width,
  onSelected,
  onMouseDown,
  onMouseEnter,
  onContextMenu,
  isSelected,
  isFirstInGroup = true,
  isLastInGroup = true,
}: {
  day: any
  height: number
  width: number
  onSelected: (day: ScheduleDayModel, event?: React.MouseEvent) => void
  onMouseDown?: (day: ScheduleDayModel, event: React.MouseEvent) => void
  onMouseEnter?: (day: ScheduleDayModel) => void
  onContextMenu?: (day: ScheduleDayModel, event: React.MouseEvent) => void
  isSelected: boolean
  isFirstInGroup?: boolean
  isLastInGroup?: boolean
}) => {
  const dayOfMonth = day ? moment(day.dayDate).date() : null
  const isSunday = day ? moment(day.dayDate).day() === 0 : false

  const isWeekendOrHoliday = day
    ? moment(day.dayDate).day() === 0 || moment(day.dayDate).day() === 6
    : false

  return (
    <div
      className={`tw-cursor-poiner tw-relative tw-flex tw-cursor-pointer tw-select-none tw-flex-col tw-justify-end tw-gap-[2px] ${day && 'hover:tw-bg-primary/10'} ${day && isSelected ? 'tw-z-10' : ''}`}
      style={{ width, height }}
      onClick={
        day && onSelected
          ? (e: React.MouseEvent) => onSelected(day, e)
          : undefined
      }
      onMouseDown={
        day && onMouseDown
          ? (e: React.MouseEvent) => onMouseDown(day, e)
          : undefined
      }
      onMouseEnter={day && onMouseEnter ? () => onMouseEnter(day) : undefined}
      onContextMenu={
        day && onContextMenu
          ? (e: React.MouseEvent) => onContextMenu(day, e)
          : undefined
      }
    >
      {day && isSelected && (
        <div className="tw-absolute tw-inset-0 tw-rounded-sm tw-bg-primary/15 tw-ring-[2px] tw-ring-inset tw-ring-primary" />
      )}
      {isWeekendOrHoliday && (
        <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-black/[0.1]" />
      )}
      {day && (
        <>
          <p
            className={`tw-pl-[2px] tw-pt-[6px] tw-text-left tw-text-xs tw-font-medium ${isSunday || day?.isHoliday ? 'tw-text-red-400' : 'tw-text-content-base'}`}
          >
            {dayOfMonth}
          </p>
          <DayItem
            day={day}
            width={width}
            isFirstInGroup={isFirstInGroup}
            isLastInGroup={isLastInGroup}
          />
        </>
      )}
    </div>
  )
}

export default DayWrapper
